import { createFileRoute } from '@tanstack/react-router'
import { AirportDetailView } from '@/components/AirportDetailView'

export const Route = createFileRoute('/_auth/airport/$icao')({
  component: RouteComponent,
})

function RouteComponent() {
  const { icao } = Route.useParams()
  return <AirportDetailView icao={icao.toUpperCase()} />
}
